import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

export default function ProjectListings() {
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState(null);
  const [bidForm, setBidForm] = useState({
    lineItemBreakdown: '',
    weeklyBurnRate: '',
    materialCosts: '',
    laborCosts: '',
    equipmentCosts: '',
    capitalNeed: '',
    requestedTerms: ''
  });

  const projects = [
    {
      id: 1,
      scope: 'Electrical',
      gc: 'BuildCorp',
      bidDeadline: 3,
      budget: '$50K-$100K',
      slotsFilled: 4,
      totalSlots: 10
    },
    {
      id: 2,
      scope: 'Plumbing',
      gc: 'PrimeBuilders',
      bidDeadline: 2,
      budget: '$30K-$70K',
      slotsFilled: 6,
      totalSlots: 10
    },
    {
      id: 3,
      scope: 'Carpentry',
      gc: 'CraftMasters',
      bidDeadline: 5,
      budget: '$40K-$90K',
      slotsFilled: 3,
      totalSlots: 10
    }
  ];

  const handleInputChange = (field, value) => {
    setBidForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleBidSubmit = () => {
    alert('Bid submitted successfully!');
    navigate('/bid-won-success');
  };

  const handleLogout = () => {
    auth.signOut();
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#000000', padding: '2rem' }}>
      {/* Header */}
      <header style={{ 
        marginBottom: '2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h1 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          color: 'white',
          margin: 0
        }}>
          Project Listings
        </h1>
        
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            backgroundColor: '#2D2D2D',
            color: 'white',
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer'
          }}
        >
          ← Dashboard
        </button>
      </header>

      {/* Project Cards */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: '1.5rem',
        marginBottom: '2rem'
      }}>
        {projects.map((project) => (
          <div key={project.id} style={{
            backgroundColor: '#1A1A1A',
            borderRadius: '12px',
            padding: '1.5rem',
            border: selectedProject?.id === project.id ? '2px solid #8B5CF6' : '1px solid #333'
          }}>
            <h3 style={{ color: 'white', fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              Scope: {project.scope}
            </h3>
            
            <div style={{ marginBottom: '1rem' }}>
              <div style={{ color: 'white', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                <strong>GC:</strong> {project.gc}
              </div>
              <div style={{ color: 'white', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                <strong>Bid Deadline:</strong> {project.bidDeadline} days
              </div>
              <div style={{ color: 'white', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                <strong>Budget:</strong> {project.budget}
              </div>
              <div style={{ color: 'white', fontSize: '0.875rem', marginBottom: '1rem' }}>
                <strong>Slots Filled:</strong> {project.slotsFilled} of {project.totalSlots}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <button
                onClick={() => setSelectedProject(project)}
                style={{
                  backgroundColor: '#8B5CF6',
                  color: 'white',
                  padding: '0.5rem',
                  borderRadius: '6px',
                  border: 'none',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Bid Now
              </button>
              <button style={{
                backgroundColor: '#8B5CF6',
                color: 'white',
                padding: '0.5rem',
                borderRadius: '6px',
                border: 'none',
                fontSize: '0.875rem',
                fontWeight: '500',
                cursor: 'pointer'
              }}>
                Unlock Early Review
              </button>
              <button style={{
                backgroundColor: '#8B5CF6',
                color: 'white',
                padding: '0.5rem',
                borderRadius: '6px',
                border: 'none',
                fontSize: '0.875rem',
                fontWeight: '500',
                cursor: 'pointer'
              }}>
                Secure Funding First
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Main Content Grid */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        gap: '2rem',
        marginBottom: '2rem'
      }}>
        {/* Left Column */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {/* Bid Submission Flow */}
          <div style={{
            backgroundColor: '#1A1A1A',
            borderRadius: '12px',
            padding: '1.5rem'
          }}>
            <h2 style={{ color: 'white', fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              Required Inputs
            </h2>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <label style={{ color: 'white', fontSize: '0.875rem', display: 'block', marginBottom: '0.5rem' }}>
                  Line-item Breakdown
                </label>
                <input
                  type="text"
                  placeholder="Enter line items"
                  value={bidForm.lineItemBreakdown}
                  onChange={(e) => handleInputChange('lineItemBreakdown', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#2D2D2D',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.875rem'
                  }}
                />
              </div>

              <div>
                <label style={{ color: 'white', fontSize: '0.875rem', display: 'block', marginBottom: '0.5rem' }}>
                  Weekly Burn Rate
                </label>
                <input
                  type="text"
                  placeholder="Enter weekly burn rate"
                  value={bidForm.weeklyBurnRate}
                  onChange={(e) => handleInputChange('weeklyBurnRate', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#2D2D2D',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.875rem'
                  }}
                />
              </div>

              <div>
                <label style={{ color: 'white', fontSize: '0.875rem', display: 'block', marginBottom: '0.5rem' }}>
                  Material Costs
                </label>
                <input
                  type="text"
                  placeholder="Enter material costs"
                  value={bidForm.materialCosts}
                  onChange={(e) => handleInputChange('materialCosts', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#2D2D2D',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.875rem'
                  }}
                />
              </div>

              <div>
                <label style={{ color: 'white', fontSize: '0.875rem', display: 'block', marginBottom: '0.5rem' }}>
                  Labor Costs
                </label>
                <input
                  type="text"
                  placeholder="Enter labor costs"
                  value={bidForm.laborCosts}
                  onChange={(e) => handleInputChange('laborCosts', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#2D2D2D',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.875rem'
                  }}
                />
              </div>

              <div>
                <label style={{ color: 'white', fontSize: '0.875rem', display: 'block', marginBottom: '0.5rem' }}>
                  Equipment Costs
                </label>
                <input
                  type="text"
                  placeholder="Enter equipment costs"
                  value={bidForm.equipmentCosts}
                  onChange={(e) => handleInputChange('equipmentCosts', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#2D2D2D',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.875rem'
                  }}
                />
              </div>

              <div>
                <label style={{ color: 'white', fontSize: '0.875rem', display: 'block', marginBottom: '0.5rem' }}>
                  Capital Need
                </label>
                <input
                  type="text"
                  value={bidForm.capitalNeed}
                  onChange={(e) => handleInputChange('capitalNeed', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#2D2D2D',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.875rem'
                  }}
                />
              </div>

              <div>
                <label style={{ color: 'white', fontSize: '0.875rem', display: 'block', marginBottom: '0.5rem' }}>
                  Requested Terms
                </label>
                <input
                  type="text"
                  placeholder="Enter requested terms"
                  value={bidForm.requestedTerms}
                  onChange={(e) => handleInputChange('requestedTerms', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#2D2D2D',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.875rem'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Bid Timing & Gamification */}
          <div style={{
            backgroundColor: '#1A1A1A',
            borderRadius: '12px',
            padding: '1.5rem'
          }}>
            <h2 style={{ color: 'white', fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              Bid Timing & Gamification
            </h2>
            
            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ color: 'white', fontSize: '1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                Countdown Timers
              </h3>
              <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
                Creates urgency to submit bids promptly.
              </p>
            </div>

            <div>
              <h3 style={{ color: 'white', fontSize: '1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                Notifications
              </h3>
              <ul style={{ color: '#999', fontSize: '0.875rem', margin: 0, paddingLeft: '1rem' }}>
                <li>Bid window closing soon</li>
                <li>Top 3 fastest to submit</li>
                <li>Fast-track slot available</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {/* Auto-trigger Features */}
          <div style={{
            backgroundColor: '#1A1A1A',
            borderRadius: '12px',
            padding: '1.5rem'
          }}>
            <p style={{ color: 'white', fontSize: '0.875rem', marginBottom: '1rem' }}>
              ConstructScore + Capital Stack Preview if financing is requested.
            </p>
            
            <h2 style={{ color: 'white', fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              Capital Stack Structuring
            </h2>
            
            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ color: 'white', fontSize: '1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                Automated recommendation:
              </h3>
              <ul style={{ color: '#999', fontSize: '0.875rem', margin: 0, paddingLeft: '1rem' }}>
                <li>% via virtual card (materials)</li>
                <li>% via short-term working capital (payroll)</li>
              </ul>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
                Rate estimate + term length
              </p>
            </div>

            <div>
              <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
                Fast-track eligibility if ConstructScore ≥ threshold
              </p>
            </div>
          </div>

          {/* Options */}
          <div style={{
            backgroundColor: '#1A1A1A',
            borderRadius: '12px',
            padding: '1.5rem'
          }}>
            <button style={{
              backgroundColor: '#8B5CF6',
              color: 'white',
              padding: '1rem',
              borderRadius: '8px',
              border: 'none',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '1rem'
            }}>
              Buy the Opportunity
            </button>
            
            <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
              Unlock GC review, submit late, secure fast-track.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Section - Bid Locking & Post-Award Workflow */}
      <div style={{
        backgroundColor: '#1A1A1A',
        borderRadius: '12px',
        padding: '1.5rem',
        marginBottom: '2rem'
      }}>
        <h2 style={{ color: 'white', fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
          Bid Locking & Post-Award Workflow
        </h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          <div>
            <h3 style={{ color: 'white', fontSize: '1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
              Lock Bid Terms
            </h3>
            <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
              Terms locked for X days post-award.
            </p>
          </div>
          
          <div>
            <h3 style={{ color: 'white', fontSize: '1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
              Auto-generate Draw Schedule
            </h3>
            <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
              Milestone tracking with embedded capital flows.
            </p>
          </div>
        </div>
      </div>

      {/* Submit Bid Button */}
      {selectedProject && (
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={handleBidSubmit}
            style={{
              backgroundColor: '#8B5CF6',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              border: 'none',
              fontSize: '1.25rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Submit Bid for {selectedProject.scope} Project
          </button>
        </div>
      )}

    </div>
  );
}
